var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { labelUserSelect } from './common';
/** @hidden */
export var CheckBox = function (props) {
    var label = props.label, id = props.id, onChange = props.onChange, value = props.value, visited = props.visited, touched = props.touched, modified = props.modified, valid = props.valid, validationMessage = props.validationMessage, others = __rest(props, ["label", "id", "onChange", "value", "visited", "touched", "modified", "valid", "validationMessage"]);
    var onValueChange = React.useCallback(function () {
        onChange({ value: !value });
    }, [onChange, value]);
    return (React.createElement("div", null,
        React.createElement("input", __assign({ type: 'checkbox', className: 'k-checkbox', onChange: onValueChange, checked: value, id: id }, others)),
        React.createElement("label", { className: 'k-checkbox-label', htmlFor: id, style: labelUserSelect }, label)));
};
//# sourceMappingURL=CheckBox.js.map